const DEFAULT_BRAND_NAME = 'Careit';

// Replace the product name in copy while leaving URLs and emails untouched.
const BRAND_NAME_PATTERN = /\bcareit\b(?!\.(?:com|org|net)\b)/gi;

// These keys name Careit itself, e.g. pointing users of a retired brand app
// back to Careit, so the brand name must not replace it.
const NON_BRANDABLE_KEYS = new Set([
  'careit-co',
  'mobile.brand-disabled.careit-hint',
  'mobile.brand-disabled.open-careit',
]);

// Careit-operated features whose copy keeps the Careit name on white-label
// apps and dashboards.
const NON_BRANDABLE_PREFIXES = ['marketplace.', 'newsletter.'];

const brandText = (value, brandName) => {
  if (typeof value !== 'string' || !value) return value;
  const normalized =
    typeof brandName === 'string' && brandName.trim()
      ? brandName.trim()
      : DEFAULT_BRAND_NAME;
  if (normalized.toLowerCase() === DEFAULT_BRAND_NAME.toLowerCase()) {
    return value;
  }
  return value.replace(BRAND_NAME_PATTERN, normalized);
};

const isNonBrandableKey = (key) => {
  if (typeof key !== 'string') return false;
  if (NON_BRANDABLE_KEYS.has(key)) return true;
  return NON_BRANDABLE_PREFIXES.some(
    (prefix) => key.startsWith(prefix) || key.includes(`.${prefix}`)
  );
};

// i18next post-processor; getBrandName supplies the current brand name.
const createBrandNamePostProcessor = (getBrandName) => ({
  type: 'postProcessor',
  name: 'brandName',
  process(value, key) {
    const keys = Array.isArray(key) ? key : [key];
    if (keys.includes(value) || keys.some(isNonBrandableKey)) {
      return value;
    }
    return brandText(value, getBrandName());
  },
});

module.exports = {
  DEFAULT_BRAND_NAME,
  brandText,
  createBrandNamePostProcessor,
  isNonBrandableKey,
};
